import { alertActions } from './alert.actions.js';
import {demandcertificationService} from "../services/demandcertification.service";
import {certificationConstants} from "../constants/certification.constants";

export const commodityActions = {
    createCommodity
};
function createCommodity(data) {
    return async (dispatch) => {
        const response = await demandcertificationService.createCommodity(data);
        if(response.id) {
            dispatch(success(response));
        } else {
            dispatch(failure(response));
            dispatch(alertActions.error(response));
        }
    };
    function success(response) { return { type: certificationConstants.CREATE_COMMODITY, payload: response } }
    function failure(error) { return { type: certificationConstants.CREATE_COMMODITY_FAILURE, payload: error } }
}